import { Vue } from "vue-property-decorator"

export default class CO2MeasureTypeModel extends Vue {
    constructor(noEmission: string, nedcEmission: string, wltpEmission: string) {
        super()

        this.noEmission = noEmission
        this.nedcEmission = nedcEmission
        this.wltpEmission = wltpEmission
    }

    noEmission: string
    nedcEmission: string
    wltpEmission: string

    ToStringArray() {
        return [this.noEmission, this.nedcEmission, this.wltpEmission]
    }
}
